export const SUCCESS = '/backoffice/customer/SUCCESS';
export const REQUEST = '/backoffice/customer/REQUEST';
export const ERROR = '/backoffice/customer/ERROR';


// WEBPACK FOOTER //
// ./src/store/customer/types.js